/**
 * The two questions the delete confirmation has to answer, as pure functions.
 *
 * IMPORTS NOTHING, ON PURPOSE, exactly like Calendar/calendarStatsText.js.
 * scripts/check-calendar.js evaluates this file in isolation and drives it with
 * the same fixtures it drives the server's own copy with, so the browser and
 * the API cannot drift into disagreeing about which subscriber is a paying one.
 *
 * THE SERVER IS THE ENFORCEMENT, ALWAYS. Everything here decides what the modal
 * shows. The API repeats both checks and refuses on its own account, because a
 * confirmation that only exists in the browser is not a confirmation.
 */

/** The plans somebody is charged for. 'comp' is not one. */
export const PAID_PLANS = ['monthly', 'annual'];

/**
 * Whether deleting this subscriber would take money off somebody who is paying,
 * and therefore whether the modal needs its second checkbox.
 *
 * Mirrors hasActivePaidSubscription in server/lib/calendarSubscribers.js, down
 * to the two independent reasons: a paid plan, or a live Square subscription id
 * whatever the plan column says. A row hand edited to comp while Square still
 * bills the card is the case that makes the second reason worth having.
 */
export function hasActivePaidSubscription(subscriber) {
  if (!subscriber) return false;
  if (subscriber.status === 'cancelled') return false;
  return PAID_PLANS.includes(subscriber.plan) || Boolean(subscriber.square_subscription_id);
}

/**
 * Whether the typed address matches, on the same terms the server compares on.
 *
 * Trimmed and lowercased, because the stored address is, and because somebody
 * copying an address out of the table gets a trailing space often enough that
 * refusing it would only teach them to distrust the form.
 */
export function confirmationMatches(typed, subscriber) {
  if (!subscriber) return false;
  const left = String(typed == null ? '' : typed).trim().toLowerCase();
  return left !== '' && left === String(subscriber.email || '').trim().toLowerCase();
}

/**
 * Whether Delete may be pressed: the address matches, and the paid subscription
 * has been acknowledged separately when there is one.
 */
export function canSubmitDelete({ typed, subscriber, cancelPaidAcknowledged }) {
  if (!confirmationMatches(typed, subscriber)) return false;
  if (hasActivePaidSubscription(subscriber) && !cancelPaidAcknowledged) return false;
  return true;
}
